export class InActiveService {
    private _timeOut: number; // in minutes
    private _counter: number;
    private _interval: NodeJS.Timeout;
    private _isInDevEnv: boolean;

    constructor() {
        this._timeOut = 0;
        this._counter = 0;
        this._interval = setInterval(() => { }, 1000);
        this._isInDevEnv = false;
    }

    public startTimer(timeOut: number, isInDevEnv: boolean = false): void {
        this._timeOut = timeOut * 60;
        this._counter = this._timeOut;
        this._interval = setInterval(this.runInterval.bind(this), 1000);
        this._isInDevEnv = isInDevEnv;
    }

    public resetTimer(): void {
        clearInterval(this._interval);
        this._counter = this._timeOut;
        this._interval = setInterval(this.runInterval.bind(this), 1000);
    }

    private onHandleInActive(): void {
        window.location.reload();
    }

    private runInterval(): void {
        this._counter--;
        if (this._counter < 0) {
            if (!this._isInDevEnv && this._timeOut > 0) {
                this.onHandleInActive();
            }
            clearInterval(this._interval);
        }
    }
}

export const inActiveService = new InActiveService();
